import React from 'react';
import { CheckCircle } from 'lucide-react';
import EnquiryForm from '../components/common/EnquiryForm';
import './Partnership.css';
import './About.css';

const BENEFITS = [
  { icon: '💰', title: 'High Commission', desc: 'Earn industry-leading commissions on every referral and deal closure with a dedicated commission tracker.' },
  { icon: '📚', title: 'Training and Support', desc: 'Regular product training, market updates, and sales enablement material provided to all partners.' },
  { icon: '📋', title: 'Exclusive Listings', desc: 'Access pre-launch pricing and exclusive projects not available to the general market.' },
  { icon: '🔒', title: 'Lead Protection', desc: 'Your client leads are protected. No double-dipping. Transparent CRM tracking for every deal.' },
  { icon: '🤝', title: 'Dedicated Manager', desc: 'Each channel partner gets a dedicated relationship manager for seamless coordination.' },
  { icon: '🏅', title: 'Partner Recognition', desc: 'Top performers featured on our website and invited to exclusive partner events.' },
];

const Partnership = () => (
  <div>
    <section className="page-hero">
      <div className="container">
        <span className="section-label">Work With Us</span>
        <h1 className="section-title light">Channel Partnership</h1>
        <p className="page-hero__sub">Join India's most transparent real estate partner network</p>
      </div>
    </section>

    <section className="partner-why-section">
      <div className="container">
        <div className="partner-why-grid">
          <div>
            <span className="section-label">Why Partner With Us</span>
            <h2 className="section-title">Grow Your Real Estate Business</h2>
            <div className="gold-divider" />
            <p className="partner-desc">
              Smart Property Solutions offers one of the most rewarding channel partner programs in the NCR and Gujarat real estate market. Whether you are an individual broker, a real estate firm, or an NRI advisor, we have the right partnership model for you.
            </p>
            <p className="partner-desc">
              We welcome developers, investors, independent brokers, NRI advisors, interior designers, architects, and anyone with a strong real estate network. Register today and start earning.
            </p>
            <ul className="partner-bullets">
              {['No Registration Fee','Immediate Activation','Real-time Commission Tracking','Co-marketing Support'].map(p=>(
                <li key={p}><CheckCircle size={16} color="var(--primary)"/> {p}</li>
              ))}
            </ul>
          </div>
          <div>
            <EnquiryForm propertyTitle="Channel Partnership" variant="default" />
          </div>
        </div>
      </div>
    </section>

    <section className="partner-benefits-section">
      <div className="container">
        <div style={{textAlign:'center',marginBottom:'48px'}}>
          <span className="section-label">Partner Benefits</span>
          <h2 className="section-title light">What You Get</h2>
        </div>
        <div className="partner-benefits-grid">
          {BENEFITS.map((b,i)=>(
            <div className="value-card" key={i}>
              <span className="value-icon">{b.icon}</span>
              <h4>{b.title}</h4>
              <p>{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default Partnership;
